export default __webpack_public_path__ + "0a1ce6c15385d966ae6776d8142ef9cc.webp";